import * as React from 'react'

/**
 * @description Users icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Users } from '@sravni/design-system-icons'
 *
 * <Users />
 * ```
 */
export const Users = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Users" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 17v-1.333c0-.708-.316-1.386-.879-1.886C12.56 13.281 11.796 13 11 13H5c-.796 0-1.559.28-2.121.781-.563.5-.879 1.178-.879 1.886V17m16 0v-1.333C18 14.5 17 13 16 13m-8-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm5-5.83a3.001 3.001 0 0 1 0 5.66"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
